var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoto = function SvgPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.572 3.358h-2.519c-.562 0-1.072-.33-1.302-.842L15.997.842A1.43 1.43 0 0 0 14.695 0h-7.39a1.43 1.43 0 0 0-1.303.842L5.25 2.516c-.23.512-.74.842-1.302.842H1.428C.639 3.358 0 3.998 0 4.785V15.53c0 .787.64 1.427 1.428 1.427h19.144c.788 0 1.428-.64 1.428-1.427V4.785c0-.788-.64-1.427-1.428-1.427ZM11 14.774a4.953 4.953 0 1 1 0-9.905 4.953 4.953 0 1 1 0 9.905Z",
    fill: "#333"
  })));
};
export default SvgPhoto;